import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';

import {Integer, DecimalRounded} from '../../../utils/NumeralParts';
import Formatters from '../../../features/shared/utils/Formatters';
import MobileChecker from "../../shared/utils/MobileChecker";

const propTypes = {
  isForPayment: PropTypes.bool,
  disbursedAmount: PropTypes.string.isRequired,
};


const renderPrincipal = (amount) => {
  const isMobile = MobileChecker();
  if(isMobile) {
      return(
    <div className="_displayFlex _justifyContent-space-between _paddingTop--small">
      <p className="subhead _textAlign_left _fontSize--normal-mobileOnly -darkBlue _marginRight--small-mobileOnly">
        Loan Principal
      </p>
      <p
        className="subhead _fontSize--normal-mobileOnly -darkBlue _whiteSpace_nowrap"
      >
        ₱ {Formatters.currencyDecimal(amount)}
      </p>
    </div>
    )
  }
      return(
        <div className="_displayFlex _justifyContent-space-between _alignItems-center">
          <h3 className="headline -darkBlue _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly">
            Loan Principal
          </h3>
          <div className='_displayFlex _justifyContent-center _alignItems-center'>
            <small className='-darkBlue _marginRight--xsmall _marginBottom--small _fontSize--normal-mobileOnly'>₱</small>
            <h2 className='headline -darkBlue _fontSize--xxlarge _fontSize--normal-mobileOnly' data-testid='principal-amount'>
              {Integer(amount)}
            </h2>
            <span className='-darkBlue _alignSelf-center emphasize _fontSize--normal-mobileOnly'
              data-testid='principal-amount-decimal'>
              {`${DecimalRounded({number: amount})}`}
            </span>
          </div>
        </div>
      )
}
const renderConvinienceFee = (isSubscriptionFee, serviceFeeAmount, serviceFee) => {
  if (isSubscriptionFee) {
    return (
      <span data-testid='service-fee-amount'>
        -
        <span
          data-testid='non-deductable-service-fee'
          className="_fontSize--small _textDecoration_line-through"
        >
          ₱ {Formatters.currencyDecimal(serviceFeeAmount)}
        </span>{' '}
        ₱ {Formatters.currencyDecimal(serviceFee)}
      </span>
    );
  } else {
    return (
      <span data-testid='service-fee-amount'>
        - ₱ {Formatters.currencyDecimal(serviceFeeAmount)}
      </span>
    );
  }
};
const renderDisbursementWithDetails = ({loanOffer, paymentPlan, isForPayment}) => {
  const { custom_fields: {
    disbursed_amount: disbursedAmount,
    service_fee_amount: serviceFeeAmount,
    service_fee: serviceFee,
    term_length: termLength
  }} = loanOffer
  const { principal_amount: principalAmount } = paymentPlan
  const isSubscriptionFee = serviceFee === 0;
  const termMode = paymentPlan.term_mode || 'month'
  const selectedTermLength = termLength || paymentPlan.term_length

  return (
    <section
      data-testid='amortizing-loan-disbursement-details'
      className='cardSection _paddingTop--xsmall _paddingBottom--xxxsmall'
    >
      <p className='subhead -primary _fontSize--large _marginTop--small'>
        {`Your ${selectedTermLength} ${capitalize(termMode)} Loan`}
      </p>
      <section className='cardSection _paddingTop--xsmall _paddingBottom--xsmall'>
        {renderPrincipal(principalAmount)}
        <div className='_displayFlex _justifyContent-space-between _borderBottom _paddingBottom--small'>
          <p
            className='_textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'
            data-testid='amortizing-disbursement-convenience-fee-label'
          >
            Convenience Fee
          </p>
          <p
            className='_fontSize--normal-mobileOnly _whiteSpace_nowrap'
          >
            {renderConvinienceFee(
              isSubscriptionFee,
              serviceFeeAmount,
              serviceFee
            )}
          </p>
        </div>
        <div className='_displayFlex _justifyContent-space-between _paddingTop--small'>
          <p className='subhead _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
            { isForPayment ? 'Supplier' : 'You'} will receive
          </p>
          <p
            className='subhead _fontSize--normal-mobileOnly _whiteSpace_nowrap'
            data-testid='disbursed-amount'
          >
            ₱ {Formatters.currencyDecimal(disbursedAmount)}
          </p>
        </div>
      </section>
    </section>
  );
}

const AmortizingDisbursement = ({loanOffer, paymentPlan, isForPayment}) => {
  return renderDisbursementWithDetails({loanOffer, paymentPlan, isForPayment});
}

AmortizingDisbursement.propTypes = propTypes;
export default AmortizingDisbursement;



// WEBPACK FOOTER //
// ./src/features/loans/components/AmortizingDisbursement.js